<div class="content-cedi-store" *ngIf="!showAddress">
  <div class="p-col-12">
    <h1>CEDI/Tiendas</h1>
  </div>

  <h3 class="first">Ciudad</h3>
  <p-autoComplete
    *ngIf="cities != null"
    name="city"
    [(ngModel)]="selectedCity"
    field="name"
    [suggestions]="filteredCities"
    (completeMethod)="filterCities($event)"
    [size]="30"
    [minLength]="1"
    placeholder="Ingresa el nombre de la ciudad"
    [dropdown]="true"
  >
    <ng-template let-brand pTemplate="item">
      {{ brand.name }}
    </ng-template>
  </p-autoComplete>

  <h3 class="first">Empresa</h3>
  <p-autoComplete
    *ngIf="companies != null"
    name="company"
    [(ngModel)]="selectedCompany"
    field="name"
    [suggestions]="filteredCompanies"
    (completeMethod)="filterCompanies($event)"
    [size]="30"
    [minLength]="1"
    placeholder="Ingresa el nombre de la empresa"
    [dropdown]="true"
  >
    <ng-template let-brand pTemplate="item">
      {{ brand.name }}
    </ng-template>
  </p-autoComplete>

  <div class="p-col-12">
    <h2>Cargar tiendas con xls</h2>
  </div>

  <div class="p-col-6">
    <p-fileUpload
      id="mu-file-cedi-load"
      name="myfile[]"
      customUpload="true"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      (uploadHandler)="loadExcelPoints($event)"
    ></p-fileUpload>
  </div>

  <a href="../../../../../assets/files/Formato_excel_MASIVOS_Tiendas.xlsx" download>Descargar archivo de ejemplo</a>
</div>

<div class="p-grid content-load-address" *ngIf="showAddress">
  <div class="p-col-12 content-load-address_header">
    <div class="create_address">
      <p-button class="p-col-12 p-md-2 p-lg-2" (click)="handleListCedi()" label="Terminar"></p-button>
    </div>
  </div>
  <div class="p-col-12 p-md-12 content-load-address_validation">
    <div class="p-grid">
      <div class="p-col-6 p-md-6 validation_header">
        <div class="validation_resume">
          <h2>Direcciones cargadas</h2>
          <p>{{ addressNotFound.length }} Direcciones no encontradas</p>
          <p>{{ addressFound.length }} Direcciones cargadas</p>
        </div>
        <div *ngIf="addressPoint.length == 0">
          <app-loading [title]="'Cargando direcciones'" [description]="'Este proceso puede tardar varios minutos…'"> </app-loading>
        </div>
        <div class="validations_tabs">
          <p-tabView>
            <p-tabPanel header="Encontradas">
              <div class="load-adress-card-content">
                {{ foundCard }} -bool
                <app-address-card
                  *ngFor="let found of addressFound; let i = index"
                  [addresspoint]="found"
                  [typeaddress]="foundCard"
                  (deletepoint)="deleteAddressFoundPoint(found.id)"
                  (updatepoint)="updateAddressFounPoint(found, i)"
                >
                </app-address-card>
              </div>
            </p-tabPanel>
            <p-tabPanel header="No encontradas">
              <div *ngFor="let notFound of addressNotFound; let i = index">
                <app-address-card
                  [addresspoint]="notFound"
                  [typeaddress]="notFoundCard"
                  (deletepoint)="deleteNotFoundPoint(i)"
                  (updatepoint)="updateAddressPoint($event, i)"
                >
                </app-address-card>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
      <div class="p-col-6 p-md-6 content-load-address_map">
        <app-map-leaflet [mapobjectid]="'map'" [markers]="mapCoordinates"></app-map-leaflet>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Editar punto" [(visible)]="showEditCedi" [style]="{ width: '50vw' }">
  <app-create-cedi-point
    [cities]="cities"
    [country]="selectedCountry"
    [labelbutton]="labelButtonCedi"
    [company]="selectedCompany"
    [filtercities]="filteredCities"
    [cediToEdit]="editCedi"
    (closecedimodal)="handleEditAddress()"
    (showtoast)="showSuccess()"
    (filteredcities)="filterCities($event)"
  ></app-create-cedi-point>
</p-dialog>

<p-toast></p-toast>
